import "./contentStyles.scss";
import GroupPhoto from "../../../../components/peoplepage/peoplePhotos/Group.jpg";
import LegoSeriousPlayImg from "../../../../assets/application-section/lego_serious_play.jpg";

const Content = () => {
  return (
    <div className="scholarship-content">
      <div className="right-content">
        <div className="middle-content">
          <div className="whoIsContent">
            <h2 >Who is Eligible?</h2>
            <ul>
              <li>US citizens, refugees, and permanent residents</li>
              <li>Have a High school GPA 2.83.</li>
              <li>Enrolled full-time at Ball State University.</li>
              <li>
                Have demonstrated financial need and completed FAFSA.
              </li>
              <li>First-year student majoring in Chemistry or Biology.</li>
              <p><em>Pre-health professionals are not eligible</em></p>
            </ul>
          </div>
          <div className="whoIsImage">
            <img src={GroupPhoto}></img>
            {/* <p><a target="_" href="/?people=show">MEET OUR I-ASCEND SCHOLARS </a></p> */}

            <p><a target="_" href="https://digitalcorps.s3.amazonaws.com/csh-website-chemistry-scholarship/build/index.html?people=show">MEET OUR I-ASCEND SCHOLARS </a></p>
          </div>
        </div>
        <div className="middle-content">
          <div className="benefitsImage">
            <img src={LegoSeriousPlayImg}></img>
          </div>
          <div className="benefitsContent">
            <h2 style={{padding: 15}}>What are the benefits of I-ASCEND?</h2>
            <ul>
              <li>Receive individualized 1-on-1 support from a faculty mentor.</li>
              <li>Get a peer mentor to help navigate college life.</li>
              <li>Participate in study-tables with other I-ASCEND Scholars.</li>
              <li>Engage in research with faculty and get paid.</li>
              <li>Build connections with top Indiana employers.</li>
              <li>Go to workshops for career development and personal support.</li>
              <li>Involve in fun activities like movie nights, field trips, and picnics.</li>
              <li>Share stories and experiences through photographs.</li>
            </ul>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Content;
